// Models
import type { User } from '../../users/models/user'

export const enum EventSeverity {
    Info = 'info',
    Success = 'success',
    Warning = 'warn',
    Error = 'error',
}

export const DEFAULT_TOAST_DURATION = 2000

export class ToastEvent {
    subject: string
    message: string | null
    icon: string | null
    user: User | null
    severity: EventSeverity

    constructor (
        subject: string,
        message: string | null = null,
        icon: string | null = null,
        user: User | null = null,
        severity: EventSeverity = EventSeverity.Info,
    ) {
        this.subject = subject
        this.message = message
        this.icon = icon
        this.user = user
        this.severity = severity
    }
}
